import React from "react";
import { useNavigate } from "react-router-dom";
import UsersList from "../../Modals/usersList";

const NotificationDetail = () => {

  const navigate = useNavigate();
  const [openUserModal, setOpenUserModal] = React.useState(false);
  const [selectedUserIds, setSelectedUserIds] = React.useState<string[]>([]);

  const usersList = [
    { id: "1", label: "John Doe", avatar: "/static/images/user_placeholder.png" },
    { id: "2", label: "Jane Smith", avatar: "/static/images/user_placeholder.png" },
    { id: "3", label: "Michael Scott", avatar: "/static/images/user_placeholder.png" },
    { id: "4", label: "Pam Beesly", avatar: "/static/images/user_placeholder.png" },
  ];

  const handleOpenAudience = () => {
    setSelectedUserIds(usersList.map((u) => u.id));
    setOpenUserModal(true);
  };

  return (
    <>
      <div className="main_title">
        <h1>Notification Detail</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
          <button onClick={() => navigate("/manage-notifications")}>
            Notification & Communication Center
          </button> -
          Notification Detail
        </p>

      </div>

      <div className="cards view_page">
        <div className="gap_p">
          <div className="vew_img no_radius w_100">
            <h6>Image</h6>
            <figure>
              <img alt="user" src="/static/images/placeholder.png" />
            </figure>
          </div>
          <div className="w_100">
            <h6>Notification Title</h6>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit.</p>
          </div>
          <div className="w_33">
            <h6>Type</h6>
            <p>Broadcast</p>
          </div>
          <div className="w_33">
            <h6>Audience</h6>
            <p><button className="anchor_link" onClick={handleOpenAudience}>All Users</button></p>
          </div>
          <div className="w_33">
            <h6>Schedule</h6>
            <p>Now - 09/01/2025 12:00 PM</p>
          </div>
          <div className="w_33">
            <h6>Created Date</h6>
            <p>01-Sept-2025</p>
          </div>
          <div className="w_100">
            <h6>Notification Message</h6>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quae id, consectetur qui debitis et ullam pariatur iure asperiores quibusdam necessitatibus facere illum accusantium. Nulla fuga est incidunt sunt amet quibusdam autem nobis sequi, doloribus odio debitis vitae nesciunt in aut? Eius dignissimos iure distinctio architecto, necessitatibus vitae veniam laudantium soluta.</p>
          </div>
        </div>
      </div>

      <UsersList
        open={openUserModal}
        onClose={() => setOpenUserModal(false)}
        setOpen={setOpenUserModal}
        userIds={selectedUserIds}
        usersList={usersList}
      />
    </>
  );
};

export default NotificationDetail;
